import { useQuery } from "@tanstack/react-query";
import { useParams, useLocation } from "react-router-dom";
import getProjectvariations from "../projectVariations";
import { queryKeys } from "../queryKeys";
import { routes } from "src/routes";
import { useState } from "react";
import useServiceStatus from "./useServiceStatus";

export default function useProjectVariations() {
  const { companyId } = useParams();
  const { data: serviceStatus } = useServiceStatus();

  const query = useQuery({
    queryKey: [
      ...queryKeys.variations(companyId),
      serviceStatus?.Deviation?.changeDate,
    ],
    queryFn: () => {
      return getProjectvariations(companyId);
    },
  });

  return query;
}
